import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const GroupMembersContainer = styled.div``;

export const GroupMembersList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px 40px;
  padding: 20px;
`;

export const GroupMembersEmptyState = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  padding: 20px;
`;

export const GroupMemberItemContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  min-width: 0;
`;

export const GroupMemberDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const GroupMemberName = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GroupMemberRole = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GroupMembersTitle = styled.h3`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;
